<template>
  <div class="container-fluid mt-2">
    <div class="row">
      <div class="card">
        <div class="card-header">
          {{ t.custom_reseller_panel.account_in_out }}
        </div>
        <DateFilter :startDate="startDate" :endDate="endDate"></DateFilter>
        <div class="card-block p-0">
          <div class="table-responsive">
            <table class="table mb-0">
              <thead>
              <tr>
                <th>{{ t.user.groups.ROLE_RESELLER }}</th>
                <th>Casino</th>
                <th>Sport</th>
                <th>{{ t.total }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-if="loading">
                <td colspan="4" align="center">
                  <Loading></Loading>
                </td>
              </tr>
              <template v-if="!loading">
                <tr v-if="data.length < 1">
                  <td colspan="4" align="center">{{ t.error.notfound_content_list }}</td>
                </tr>
                <tr v-for="d in data">
                  <td>{{ d.reseller.username }}</td>
                  <td>
                  <span class="amount">
                    <router-link :to="{query: {casino_report: d.reseller.id}}">
                      {{ d.data.casino_profit | toMoney(session.currency)  }}
                    </router-link>
                  </span>
                  </td>
                  <td>
                  <span class="amount">
                    {{ d.data.bet_profit | toMoney(session.currency)  }}
                  </span>
                  </td>
                  <td>
                  <span class="amount">
                    {{ (( parseFloat(d.data.casino_profit) + parseFloat(d.data.bet_profit)).toFixed(2)) | toMoney(session.currency) }}
                  </span>
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <sweet-modal width="100%" ref="cp" v-on:close="closeCasinoProviderReport()">
        <ProviderCasino v-if="$route.query.casino_report > 0" :id="$route.query.casino_report" :start="startDate" :end="endDate"/>
    </sweet-modal>
  </div>
</template>

<script>
import DateFilter from "../DateFilter";
import Loading from "../Loading";
import ProviderCasino from "../views/ProviderCasino";
export default {
  name: "AccountCasino",
  components: {Loading, DateFilter, ProviderCasino},
  data() {
    return {
      session: window.session,
      startDate: moment().startOf('week').add(1, 'days').format("DD MMMM YYYY ddd"),
      endDate: moment(new Date()).format("DD MMMM YYYY ddd"),
      data: [],
      loading: false,
      t: this.$root.t
    }
  },
  mounted() {
    this.fetchTransactions(this.startDate, this.endDate, false);
  },
  watch: {
    '$route.query.casino_report' () {
      if(this.$route.query.casino_report > 0)
        this.$refs.cp.open()
    },
    
  },
  methods: {
    closeCasinoProviderReport () {

        this.$router.back()
    },
    fetchTransactions(from, to){
      this.startDate = from;
      this.endDate = to;
      this.loading = true;
      this.$http.get(api + 'api/v1/reports/generalProfitReport', {
        params: {
          direction: 'desc',
          rangeDateTime: {
            from: from ? from : moment(moment(new Date()).format()).add(-2, 'd').format('YYYY-MM-DD'),
            to: to ? to : moment().add(+1, 'd').format("YYYY-MM-DD")
          }
        }
      })
      .then(response => {
        this.data = response.body;
        this.loading = false
      }, response => {
        this.loading = false
      })

    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/AccountCasino.vue